import React from 'react';
import { Link } from 'react-router-dom';
import style from './BlockImgNlt.scss';
import * as icones from '../Icones'


const FichierTypesPresent = props => {
    let fakeState = {
        audio: false,
        document: false,
        video: false,
        download: false
    };
    for (let indice in props.fichierTypePresent) {
        let id = props.fichierTypePresent[indice].id;
        if (id === 6 || id === 4) {
            fakeState.audio = true;
        } else if (id === 5) {
            fakeState.document = true;
        } else if (id === 2) {
            fakeState.video = true;
        }
        if (id === 4 || id === 5) {
            fakeState.download = true;
        }
    }
    let classes = props.classes || { root: "" };
    return (
        <div
            className={"mt-1 row media-icons justify-content-center " + classes.root}
        >
            {fakeState.audio && (
                <span className="pr-3">
                    <icones.ecouterMin width={22} color={"#fff"} />
                </span>
            )}
                <span className="pr-3">
                    <icones.lireMin width={18} color={"#fff"} />
                </span>
            {/* {fakeState.document && (
                <span className="pr-3">
                    <icones.lireMin width={18} color={"#fff"} />
                </span>
            )} */}
            {fakeState.video && (
                <span className="pr-3">
                    <icones.regarderMin width={25} color={"#fff"} />
                </span>
            )}
            {fakeState.download && (
                <span className="pr-3">
                    <icones.telechargerMin width={20} color={"#fff"} />
                </span>
            )}
        </div>
    );
};


export class BlockImgNlt extends React.Component {
    render() {
        const { imgSrc, fichierTypePresent } = this.props
        return (
            <div className={style.blockImgNlt}>
                <figure>
                    <img src={imgSrc || "https://www.missiontimothee.fr/ftp/media/thumb/bff05b9ab6e860055789612c031d3dbe46c07017.jpg"} />
                    <div className={style.caption}>
                        <div className={style.blur} />
                        <div className={style.captionContent}>
                            <span className="text-center">
                                {/* <span className="pr-3">
                                    <icones.lireMin width={18} color={"#fff"} />
                                </span>
                                <span className="pr-3">
                                    <icones.regarderMin width={25} color={"#fff"} />
                                </span>
                                <span className="pr-3">
                                    <icones.telechargerMin width={20} color={"#fff"} />
                                </span>
                                <span className="pr-3">
                                    <icones.ecouterMin width={22} color={"#fff"} />
                                </span> */}
                                <FichierTypesPresent  fichierTypePresent={fichierTypePresent}/>
                            </span>
                        </div>
                    </div>
                </figure>
            </div>

        );
    }
}
